/**
 * Owner: Masa Bayu
 * File: observability.ts
 * Date:Time: 2026-09-15 19:18
 * Description: QXRead T0 observability event foundation (no PII payloads).
 */
export const QXREAD_OBSERVABILITY_EVENTS = [
    'qxread.session.state_change',
    'qxread.entitlement.verify',
    'qxread.reader.launch_denied',
    'qxread.reader.launch_allowed',
    'qxread.pwa.install_state',
    'qxread.offline.prepare_denied',
    'qxread.error.recorded',
    'qxread.route.guard',
    'qxread.commerce.eligibility',
    'qxread.commerce.attribution',
    'qxread.commerce.ledger_separation',
    'qxread.commerce.payment_intent',
    'qxread.commerce.payment_attempt',
    'qxread.commerce.payment_callback',
    'qxread.commerce.order_confirmed',
    'qxread.commerce.entitlement_issued',
    'qxread.library.projected',
    'qxread.library.progress_updated',
    'qxread.library.offline_decision',
    'qxread.library.sync_state',
    'qxread.library.launch_intent',
    'qxread.library.resume_intent',
    'qxread.library.query',
    'qxread.library.version_awareness',
    'qxread.library.continuity',
    'qxread.library.sync_enqueue',
    'qxread.library.sync_reconcile',
    'qxread.library.sync_recovery',
    'qxread.library.access_resilience',
    'qxread.library.entitlement_revalidate',
    'qxread.library.session_change',
    'qxread.library.launch_contract',
    'qxread.library.deep_link',
    'qxread.library.collection',
    'qxread.library.favorite',
    'qxread.library.organization_view',
    'qxread.library.org_change',
    'qxread.library.share_reference',
    'qxread.library.share_handoff',
    'qxread.reader.handoff',
    'qxread.reader.content_access_grant',
    'qxread.reader.deep_link_handoff',
    'qxread.reader.return_route',
    'qxread.reader.bridge_session',
    'qxread.reader.reading_continuity',
    'qxread.reader.position_restore',
    'qxread.reader.runtime_intent',
    'qxread.reader.denial_recovery',
    'qxread.reader.grant_recheck',
    'qxread.reader.integration_journey',
    'qxread.author.account_bound',
    'qxread.author.surface_access',
    'qxread.author.dashboard_projected',
    'qxread.author.writer_launch_intent',
    'qxread.author.publish_created',
    'qxread.author.publish_readiness',
    'qxread.author.publish_submitted',
    'qxread.author.publish_self_approve_denied',
    'qxread.author.publish_review_recorded',
    'qxread.author.publish_released_live',
    'qxread.author.storefront_upserted',
    'qxread.author.storefront_preview',
    'qxread.author.sales_projected',
    'qxread.author.earnings_projected',
    'qxread.author.payout_requested',
    'qxread.author.analytics_projected',
    'qxread.author.journey_composed',
    'qxread.admin.operator_bound',
    'qxread.admin.surface_access',
    'qxread.admin.executive_projected',
    'qxread.admin.ops_config',
    'qxread.admin.review_opened',
    'qxread.admin.review_decided',
    'qxread.admin.review_queue_projected',
    'qxread.admin.moderation_opened',
    'qxread.admin.moderation_acted',
    'qxread.admin.commerce_ops_projected',
    'qxread.admin.audit_recorded',
    'qxread.admin.health_projected',
    'qxread.admin.journey_composed',
    'qxread.advanced.pwa_install_projected',
    'qxread.advanced.pwa_sw_registered',
    'qxread.advanced.notification_preference',
    'qxread.reward.balance_state',
    'qxread.reward.withdrawal_request',
    'qxread.publication.bind',
    'qxread.publication.lifecycle',
    'qxread.publication.preview_decision',
];
export function createQxreadTelemetryEvent(options) {
    if (!QXREAD_OBSERVABILITY_EVENTS.includes(options.name)) {
        throw new Error('QXRead observability event name is unknown');
    }
    if (typeof options.correlationId !== 'string' || options.correlationId.length === 0) {
        throw new Error('QXRead telemetry correlationId is required');
    }
    const attrs = options.attributes ?? {};
    for (const key of Object.keys(attrs)) {
        if (/password|token|secret|email|ssn/i.test(key)) {
            throw new Error(`QXRead telemetry must not include sensitive key "${key}"`);
        }
    }
    return Object.freeze({
        name: options.name,
        at: options.at ?? new Date().toISOString(),
        correlationId: options.correlationId,
        attributes: Object.freeze({ ...attrs }),
    });
}
//# sourceMappingURL=observability.js.map